module.exports = __webpack_public_path__ + "static/media/Pattern11.c790c13d.png";